export default __webpack_public_path__ + "static/media/matic.d6c2bc8b.svg";